export const langs = ['fr', 'en'];
export const langsDisplay = {
  fr: 'Français',
  en: 'English',
};
